import { VideoPlatform } from '../../constants'
import composeRegex from '../composeRegex'
import videoPlatformRegex from '../videoPlatformRegex'

/**
 * Composes a regex pattern for a given array of video platforms.
 *
 * @param platforms - The video platforms to compose the pattern for.
 * @returns A regex pattern that matches the given video platforms.
 */
function composeVideoPlatformPattern(options: {
    enabledPlatforms: VideoPlatform[]
}) {
    return composeRegex(
        options.enabledPlatforms.map((platform) =>
            videoPlatformRegex(platform),
        ),
    )
}

export default composeVideoPlatformPattern
